import { STORY_STEPS, type StoryStepId } from "../data/steps";
import { STORY_STEP_IMAGES } from "./StoryMedia";

type StoryProgressProps = {
  readonly step: StoryStepId;
  readonly onStepChange: (step: StoryStepId) => void;
};

/**
 * Summary of the journey: a drawn line punctuated by a node per step, each one
 * a shortcut into its chapter. The line fills up to the chapter being read.
 */
export function StoryProgress({ step, onStepChange }: StoryProgressProps) {
  return (
    <nav className="nbs-story-summary" aria-label="Parcours d’introduction">
      <div className="nbs-story-summary__intro">
        <p className="nbs-story-summary__eyebrow">Le parcours</p>
        <h2 className="nbs-story-summary__title">
          Six étapes pour lire les services écosystémiques
        </h2>
      </div>

      <ol className="nbs-story-summary__list">
        {STORY_STEPS.map((item, index) => (
          <li
            key={item.id}
            className="nbs-story-summary__item"
            data-state={item.id === step ? "current" : item.id < step ? "done" : "todo"}
          >
            <button
              type="button"
              className="nbs-story-summary__btn"
              aria-current={item.id === step ? "step" : undefined}
              onClick={() => onStepChange(item.id)}
            >
              <span className="nbs-story-summary__node" aria-hidden="true" />
              <span className="nbs-story-summary__thumb" aria-hidden="true">
                <img src={STORY_STEP_IMAGES[item.id]} alt="" loading="lazy" />
              </span>
              <span className="nbs-story-summary__index">
                Étape {String(index + 1).padStart(2, "0")}
              </span>
              <span className="nbs-story-summary__label">{item.hint}</span>
              <span className="nbs-story-summary__desc">{item.label}</span>
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
}
